import Vue from 'vue';
import config from '@/config/config.json';
import { FAMILIES_ROUTES } from '@/constants/routes';

class FamiliesService {
  constructor() {}

  async getAllNames() {
    const url = `${config.apiUrl}${FAMILIES_ROUTES.BASE_URL}/${FAMILIES_ROUTES.NAMES}/${FAMILIES_ROUTES.ALL}`;
    const response = await Vue.prototype.$http.get(url);

    return response.data;
  }

	async getNames(isMana) {
    const url = `${config.apiUrl}${FAMILIES_ROUTES.BASE_URL}/${FAMILIES_ROUTES.NAMES}`;
    const response = await Vue.prototype.$http.get(url, {
      params: {
        isMana: isMana
      }
    });

    return response.data;
  }
}

export default new FamiliesService();
